import React from 'react';

import { TopicsBlock } from '../../_components/TopicsBlock';
import { TopicsBlockProps } from './types';

import classes from './index.module.scss';

export const TopicsBlockGraphQL: React.FC<TopicsBlockProps> = props => {
  const {
    id,
  } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <TopicsBlock topicsBlock={props} />
    </div>
  );
};

export default TopicsBlockGraphQL;
